<div aria-label="upload-documents-panel">
  @if (!limitFour) {
    <div class="document-upload-panel flex flex-wrap items-end gap-4 p-fluid">
      <div class="w-full md:flex-1 field">
        <label class="font-semibold">File Types:</label>
        <p-multiSelect
          placeholder="Select File Types"
          class="w-full"
          [filter]="false"
          [options]="isHhAuthForPacUser ? hhAuthForPacDocumentTypes : documentTypes"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="selectedDocumentTypes"
          (onChange)="showUploadButton(selectedDocumentTypes)"
          display="chip"
        ></p-multiSelect>
      </div>
      <div class="w-full md:flex-1 field">
        <label class="font-semibold">Description:</label>
        <input
          pInputText
          type="text"
          maxlength="40"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="fileDescription"
          >
        </div>
        <div class="w-full md:flex-1 field flex">
          @if (showButton) {
            <document-upload-select
              [multiple]="false"
              [maxFileSize]="maxFileSize"
              [maxFileNameSize]="maxFileNameSize"
              [accept]="allowedExtensions.join()"
              (selectFiles)="addFile($event)"
              (errorValidation)="onError($event)"
              >
            </document-upload-select>
          }
        </div>
        @if (limitFour) {
          <div>You have reached your limit of 4 files.</div>
        }
      </div>
    }
    @if (uploadedFiles.length) {
      <div>
        <p-table [value]="uploadedFiles" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 15rem">File Name</th>
              <th style="width: 15rem">Document Type</th>
              <th style="width: 9rem">Description</th>
              <th style="width: 3rem">File Size</th>
              <th style="width: 7rem">&nbsp;</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-file let-ri="rowIndex">
            <tr>
              <td style="width: 15rem">
                <span [pTooltip]="file.documentFileName"
                  tooltipPosition="bottom"
                  >
                  {{file.documentFileName}}
                </span>
              </td>
              <td style="max-width: 17rem">
                <span class="truncate" [pTooltip]="file.documentTypes && file.documentTypes.join(', ')" tooltipStyleClass="tooltip-xl-size">
                  {{ file.documentTypes && file.documentTypes.join(', ') }}
                </span>
              </td>
              <td style="width: 11rem">
                <div class="p-text-break-word">
                  {{file.description}}
                </div>
              </td>
              <td style="width: 3rem">{{file.fileMetaData.size}} Bytes</td>
              <td style="width: 7rem">
                <button
                  pButton
                  type="button"
                  label="Delete"
                  icon="pi pi-trash"
                  (click)="removeItem(ri)"
                ></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }

    @if (uploadedFiles.length && !autoUpload) {
      <div class="pt-4 flex justify-end">
        <button
          pButton
          type="button"
          label="Save"
          class="p-button-action"
          [disabled]="isUploading"
          (click)="uploadDocuments();"
        ></button>
      </div>
    }

    <p-dialog
      header="Warning"
      appendTo="body"
      [(visible)]="display"
      [style]="{ width: '500px' }"
      [modal]="true"
      >
      @if (fileNameInvalidErrors) {
        The file name contains invalid characters. Please rename the file and try again.
      }
      @if (!fileNameInvalidErrors && fileTypeErrors) {
        Please upload only {{ allowedExtensions.join(', ') }}
      }
      @if (!fileNameInvalidErrors && !fileTypeErrors && fileSizeErrors) {
        Maximum upload size is {{ maxFileSize / (1024 * 1024) }}Mb
      }
      @if (!fileNameInvalidErrors && !fileTypeErrors && !fileSizeErrors && fileNameSizeErrors) {
        Maximum upload file name is {{ maxFileNameSize }} symbols
      }

      <p-footer>
        <button
          pButton
          type="button"
          icon="pi pi-check"
          label="OK"
          (click)="display = false"
          >
        </button>
      </p-footer>
    </p-dialog>
  </div>
  <p-confirmDialog
    #cd
    header="Confirmation"
    message="Does this document need to be reviewed by Carelon staff?"
    appendTo="body"
    [closable]="false"
    [closeOnEscape]="false"
    rejectButtonStyleClass="p-button-info"
    rejectLabel="No"
    acceptLabel="Yes"
    >
  </p-confirmDialog>

